.busyContainer {
  background-color: #1a1a1a;
  border: 1px solid #333;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--mantine-radius-xl);
  padding: var(--mantine-spacing-xl);
}

.chatSurface {
  position: absolute;
  inset: 0;
  z-index: 0;
  background-color: #464646;
  border-radius: inherit;
}

.chatFlames {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  overflow: hidden;
  pointer-events: none;
  transition: height 300ms ease;
}

.busyText {
  text-align: center;
  white-space: pre-line;
}
